<template>
    <q-toggle
        v-if="isSwitch"
        v-model="innerValue"
        checked-icon="check"
        color="green"
        unchecked-icon="clear"
    >
        <slot name="content" />
    </q-toggle>

    <q-checkbox
        v-else
        v-model="innerValue"
        color="positive"
    />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    isSwitch: Boolean,
    modelValue: null,
})

const emit = defineEmits(['update:model-value'])

const innerValue = computed({
    get: () => props.modelValue,
    set: val => emit('update:model-value', val),
})
</script>
